module.exports = {
	"selectors": {
		"date": "Date",
		"card_brand": "Card brand",
		"card_type": "Card type",
		"card_country": "Card country",
		"customer_type": "Customer type",
		"customer_id": "Customer ID",
		"guid": "GUID",
		"card_number": "Card number",
		"widget_mode": "Widget mode",
		"last_status_change": "By last status change date",
		"processor": "Processor",
		"payment_system": "System",
		"payment_type": "Payment type",
		"type": "Type",
		"status": "Status",
		"country": "Country",
		"customer_country": "Customer country",
		"token_country": "Country by IP",
		"customer_or_token_country": "Country (customer's or IP)",
		"currency": "Currency",
		"customer_currency": "Customer currency",
		"processor_currency": "Processor currency",
		"fee_currency": "Fee currency",
		"order_currency": "Order currency",
		"error_type": "Failure type",
		"error_subtype": "Failure subtype",
		"purse": "Purse",
		"user": "User",
		"no_user": "No user",
		"old_status": "Old status",
		"new_status": "New status",
		"bank": "Bank",
		"ban_scope": "Ban scope",
		"no_bank": "No bank",
		"platform": "Platform",
		"name_or_url": "Name or URL",
		"refcodes": "Refcodes",
		"log_type": "Type",
		"log_action": "Action",
		"elements_per_page": "Elements per page",
		"billing_currency": "Billing currency",
		"integration_status": "Status",
		"system_payment_type": "Payment type",
		"continent": "Continent",
		"period": "Period",
		"sort_type": "Sorting",
		"fee_type": "Fee",
		"alert_type": "Type",
		"processor_channel": "Processor channel",
		"no_processor_channel": "No processor channel",
		"billing_types": "Billing types",
		"event_log_types": "Type",
		"others": "Others",
		"supervising_manager": "Supervising manager",
		"callback_status": "Status",
		"title": "Title",
		"ftd": "FTD",
		"deposit_segment": "Deposit segment",
		"three_ds_status": "3DS status",
		"purse_country": "Purse country",
		"no_purse_country": "No purse country",
		"amount": "Amount",
		"failure_code": "Failure code",
		"failure_message": "Failure message",
		"no_failure_type": "No failure type",
		"show_unused": "Show unused",
		"provider": "Provider",
		"operation_type": "Operation type",
		"refund_reason": "Refund reason",
		"payment_flow": "Payment flow",
		"three_ds_eci": "3DS ECI",
		"three_ds_flow": "3DS flow",
		"cascade_number": "Cascade number",
		"attempt_number": "Attempt number",
		"decline_reason": "Decline reason",
		"decline_type": "Decline type",
		"decline_code": "Decline code",
		"decline_message": "Decline message",
		"from_system": "From System",
		"to_system": "To System",
		"email": "Email",
		"failure_category": "Failure category",
		"failure_responsibility": "Failure responsibility",
		"failure_kind": "Failure kind",
		"failure_kind_analytic_groups": "Failure kind analytics groups",
		"customer_types": {
			"real": "Real",
			"test": "Test",
			"test_partner": "Test partner"
		},
		"dates": {
			"from": "From",
			"to": "To",
			"whole_period": "Whole period",
			"last_month": "Last month",
			"current_month": "Current month",
			"thirty_days": "30 days",
			"seven_days": "7 days",
			"week": "Week",
			"yesterday": "Yesterday",
			"today": "Today"
		},
		"placeholder": {
			"default": "Nothing selected",
			"purse": "Enter purse number",
			"card_number": "411111...1111",
			"comma_separated": "Enter comma separated values",
			"name_or_url": "Enter processor name or URL"
		},
		"helpers": {
			"select_all": "Select all",
			"clear": "Clear",
			"search": "Search"
		},
		"country_areas": {
			"ru": "Russian Federation",
			"cis": "CIS",
			"euro_union": "Europe (EU)",
			"not_euro_union": "Europe (Non EU)",
			"west_asia": "West Asia",
			"east_asia": "East Asia",
			"africa": "Africa",
			"australia_and_oceania": "Australia and Oceania",
			"south_america": "South America",
			"north_america": "North America",
			"others": "Others"
		},
		"order_columns_title": "Columns",
		"order_columns": {
			"amount": "Amount",
			"bank_id": "Bank",
			"billing_amount": "Billing amount",
			"billing_currency": "Billing currency",
			"billing_type": "Billing type",
			"refundable_amount": "Refundable amount",
			"created_at": "Created at",
			"customer": "Customer",
			"customer_country": "Customer country",
			"customer_fee": "Customer fee",
			"deposit_number": "Deposit number",
			"failure_code": "Failure code",
			"failure_type": "Failure type",
			"id": "ID",
			"jurisdiction": "Jurisdiction",
			"locale": "Locale",
			"order_currency": "Order currency",
			"personal_fee": "Personal fee",
			"platform": "Platform",
			"processor_account_title": "Processor account",
			"processed_at": "Processed at",
			"processor_channel_id": "Processor channel",
			"processor_fee": "Processor fee (calculated)",
			"subprocessor_fee": "Subprocessor fee (calculated)",
			"processor_fee_external": "Processor fee (external)",
			"processor_name": "Processor",
			"project_fee": "Project fee",
			"project_name": "Project",
			"purse": "Purse",
			"refcode": "Refcode",
			"rejection_reason": "Rejection reason",
			"scheduled_at": "Scheduled at",
			"secondary_txids": "Secondary transaction IDs",
			"status": "Status",
			"status_updated_at": "Status updated at",
			"sphere_link": "Sphere link",
			"support_status": "Support status",
			"system_name": "System",
			"three_ds_status": "3DS status",
			"token_country": "Country by IP",
			"txid": "Transaction ID",
			"type": "Type",
			"updated_at": "Updated at",
			"user": "User",
			"purse_country": "Purse country",
			"card_type": "Card type",
			"three_ds_eci": "3DS ECI",
			"three_ds_flow": "3DS flow",
			"widget_type": "Widget type",
			"os_type": "OS type",
			"user_agent": "User agent",
			"vwo_variations": "VWO variations",
			"tracking_id": "Tracking ID",
			"widget_origin": "Widget origin",
			"app_type": "App type",
			"device_type": "Device type",
			"widget_submode": "Widget opening location",
			"three_ds_liability_shift": "3DS liability shift",
			"three_ds_challenge_indicator": "3DS challenge indicator",
			"rrn": "RRN",
			"tags": "Tags",
			"failure_category": "Failure category",
			"failure_responsibility": "Failure responsibility",
			"failure_kind": "Failure kind",
			"payout_delay_reasons": "Payout delay reasons",
			"rfd_groups": "RFD groups",
			"requested_at": "Requested at",
			"deposit_segment": "Deposit segment"
		},
		"deposit_default_amount_strategy": {
			"last_deposit": "Last deposit",
			"average": "Average",
			"rule_or_rating": "Rule or rating",
			"max_of_last_deposit_and_average": "Max of last deposit and average"
		},
		"widget_screen": {
			"deposit": "Deposit",
			"withdraw": "Withdraw",
			"deposit-form": "Deposit form",
			"withdraw-form": "Withdraw form",
			"clarification-form": "Clarification form",
			"frame": "System frame",
			"form": "System form",
			"confirmation": "Confirmation",
			"instruction": "Instruction",
			"message": "Message"
		},
		"vwo": {
			"name": "VWO Variation",
			"not_participating": "<Not participating>"
		},
		"timerange": {
			"time": "Time",
			"start": "Start time",
			"end": "End time"
		},
		"widget_type": {
			"label": "Widget type",
			"full": "Full",
			"one_click": "1-click"
		},
		"app_type": {
			"label": "App type",
			"web": "Web",
			"mobile_app": "Mobile app"
		},
		"device_type": {
			"label": "Device type",
			"phone": "Phone",
			"desktop": "Desktop",
			"tablet": "Tablet",
			"other": "Other"
		},
		"os_type": {
			"label": "OS type",
			"android": "Android",
			"ios": "iOS",
			"ipad_os": "iPadOS",
			"chrome_os": "ChromeOS",
			"windows": "Windows",
			"linux": "Linux",
			"mac": "Mac",
			"other": "Other"
		},
		"no_data": "No data",
		"widget_submode": "Widget opening location",
		"dispute": {
			"type": "Type",
			"provider": "Provider",
			"status": "Status",
			"category": "Chargeback category",
			"period": "Chargeback period",
			"reason": "Reason",
			"fraud_type": "Fraud type",
			"external_id": "External ID"
		},
		"tags": "Tags",
		"rfd_groups": {
			"label": "RFD groups",
			"verification": "Verification",
			"3rd_party": "3rd party",
			"intersection": "Intersection",
			"fraud": "Fraud"
		},
		"declare_refund_type": {
			"backoffice": "Backoffice",
			"test_widget": "Test widget",
			"bank_transfer": "Bank transfer",
			"other": "Other"
		}
	}
};